import { Dimmer, Loader } from 'semantic-ui-react';
import styled from 'styled-components';

const Centered = styled.div`
	position: fixed;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

function Loading() {
	return (
		<Centered>
			<Dimmer active inverted>
				<Loader size="large">Loading...</Loader>
			</Dimmer>
		</Centered>
	);
}

export default Loading;
